import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { QuoteStatusCell } from '../QuoteStatusCell/QuoteStatusCell';
import { TsrctQuoteItemStatus, TsrctQuoteItemUpdatableStatus } from '@/generated/gql/graphql';
export interface NegotiationCaseQuoteStatusCellProps<R extends GridValidRowModel = any> {
  value: TsrctQuoteItemStatus;
  row: R;
  viewOnly?: boolean;
  onStatusToggle?: (rowId: string | number, newStatus: TsrctQuoteItemUpdatableStatus) => void;
}

export const NegotiationCaseQuoteStatusCell = <R extends GridValidRowModel = any>({
  value,
  row,
  viewOnly = true,
  onStatusToggle,
}: NegotiationCaseQuoteStatusCellProps<R>) => {
  return (
    <QuoteStatusCell<R, TsrctQuoteItemStatus | TsrctQuoteItemUpdatableStatus, TsrctQuoteItemUpdatableStatus>
      value={value}
      row={row}
      viewOnly={viewOnly}
      onStatusToggle={onStatusToggle}
      uncheckedValue={TsrctQuoteItemUpdatableStatus.NOT_REQUESTED}
      checkedValue={TsrctQuoteItemUpdatableStatus.REQUESTED}
    />
  );
};
